import { Text, View } from 'react-native'
import { styled } from '~/utils'

export const Header = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.sizingMicro,
    },
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      flex: 1,
      flexShrink: 1,
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreeandhalfpulse,
    },
  }
})

export const TagContainer = styled(View, theme => {
  return {
    base: {
      flexShrink: 0,
    },
  }
})

export const ButtonContainer = styled(View, theme => {
  return {
    base: {
      flexShrink: 0,
    },
  }
})
